import React from "react";
import TranslatedPage from "../../containers/TranslatedPage";
import IconFromPath from "../../containers/TranslatedPage/IconFromPath";
import "./WhiteMondayAboutIhopa.scss";
const WhiteMondayAboutIhopa = () => {
  return (
    <section className="white-monday-about-ihopa large-padding gray-bg" id="about-ihopa">
      <div className="main-container">
        <div className="content-wrapper">
          <h1 className="hero-heading how-it-works">
            <TranslatedPage path="whitemonday.content_blocks.whitemonday_about.heading" />
          </h1>
          <div className="about-copy">
              <TranslatedPage path="whitemonday.content_blocks.whitemonday_about.content" />
          </div>
          <div className="selling-points">
            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point1.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point1.heading" />
              </div>
            </div>

            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point2.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point2.heading" />
              </div>
            </div>
            
            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point3.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point3.heading" />
              </div>
            </div>
            
            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point4.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point4.heading" />
              </div>
            </div>
            
            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point5.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point5.heading" />
              </div>
            </div>
            
            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point6.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point6.heading" />
              </div>
            </div>
            
            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point7.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point7.heading" />
              </div>
            </div>
            
            <div className="selling-point-item">
              <IconFromPath
                iconSize="32"
                className="icon primary-color"
                path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point8.icon"
                custom={true}
              />
              <div className="selling-point-name">
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_about_ihopa_selling_point8.heading" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhiteMondayAboutIhopa;
